import $ from 'jquery';

import AppDomain from '../../core/AppDomain';
import normalizeNLZipCode from '../../core/normalizeNLZipCode';

/**
 * jQuery plugin to normalizes zip code value for Netherlands.
 * This is required to update old zip code in wrong shape.
 */
$.fn.normalizeZipCodeForNL = function () {
    if (AppDomain.isNL()) {
        const $zipInput = this.find('input[name=zip]');
        const zipCode = $zipInput.val() || '';
        const normalizedZipCode = normalizeNLZipCode(zipCode);

        $zipInput.val(normalizedZipCode);
    }

    return this;
};



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/layout/address-form/normalize-nl-zip-code-plugin.js
 **/